import {Button, DatePicker, Divider, Flex, Form, Input, Popover, Radio, Select, Typography} from "antd";
import {useForm} from "antd/es/form/Form";
import {GrCircleQuestion} from "react-icons/gr";
import React, {useEffect, useState} from "react";
import UploadDoc from "../component/UploadDoc";
import {resultStore} from "../../../store/admissions/admissionStore";
import {stepsStore} from "../../../store/admissions/stepperStore";
import {getRequest} from "../../../api/httpRequest";
import useBreakpoint from "antd/es/grid/hooks/useBreakpoint";

const style: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
};

interface ICountry {
    Code: string,
    Name: string,
    FullName: string,
    alpha2: string,
    InternationalName: string
}

export default function Step11() {

    const [form] = useForm();
    const {result, setResult} = resultStore();
    const [formEnabled, setFormEnabled] = React.useState(false);
    const {stepsData, setStepsData} = stepsStore();
    const [countries, setCountries] = useState<ICountry[]>([]);
    const {xl} = useBreakpoint()

    useEffect(() => {
        if (result.basistraining === "бюджетная") {
            setResult({
                ...result,
                notcontract: true
            })
            setStepsData({
                currentStep: stepsData.currentStep + 1,
                completedSteps: [...stepsData.completedSteps],
                skippedSteps: [...stepsData.skippedSteps, stepsData.currentStep],
                nextStep: false,
                backStep: stepsData.backStep + 1,
                forwardStep: 0
            })
        }
        getRequest("/server/proxy/contracts/countries")
            .then((res: any) => {
                setCountries(res.data);
            })
    }, []);

    function UploadItem(props: any) {
        return (
            <Flex gap={24} style={{width: "100%"}}>
                <Flex style={{width: "50%"}} justify={"flex-end"}>
                    <Typography.Text>{props.title}</Typography.Text>
                </Flex>
                <Flex style={{width: "50%"}} align={"center"} justify={"flex-start"} gap={16}>
                    <UploadDoc id={`${props.title}_F`} disabled={!formEnabled} onFileChange={() => {}}/>
                    <Popover content={props.help} title={props.help}
                             trigger="hover">
                        <Button disabled={!formEnabled} type={"text"} icon={<GrCircleQuestion/>}/>
                    </Popover>
                </Flex>
            </Flex>
        )
    }

    return (
        <Flex vertical style={{width: '100%'}} justify={"center"} align={"center"} gap={16}>
            <Flex justify={"center"} align={"center"} gap={16} vertical={true}>
                <Typography.Text style={{fontSize: 20}} strong>Выберите вариант заключения договора</Typography.Text>
                <Flex vertical={true} gap={8}>
                    <Radio.Group
                        style={style}
                        onChange={(value) => {
                            if (value.target.value === 3) {
                                setFormEnabled(true);
                            } else {
                                setFormEnabled(false);
                            }

                            setResult({
                                ...result,
                                Iampayer: value.target.value === 1,
                                notcontract: value.target.value === 2,
                                otherpayerChecked: value.target.value === 3,
                            })
                            setStepsData({...stepsData, nextStep: true})
                        }}
                        options={[
                            {
                                value: 2,
                                label: "Пропустить заключение договора"
                            },
                            {
                                value: 1,
                                label: "Заказчиком по договору указать меня"
                            },
                            {
                                value: 3,
                                label: "Ввести данные другого заказчика по договору"
                            }
                        ]}
                    />
                </Flex>
            </Flex>
            <Divider style={{margin: 2}}/>
            <Flex vertical={true} align={"center"} gap={16}>
                <Typography.Text style={{fontSize: 16}} strong>Введите персональные данные заказчика</Typography.Text>
                <Form
                    form={form}
                    disabled={!formEnabled}
                    style={{width: xl ? "800px" : "100%"}}
                    name="documents"
                    size={xl ? "small" : "large"}
                    labelCol={{span: 7}}
                    onFinish={values => () => {
                    }}
                    requiredMark={false}
                >
                    <Flex style={{width: "100%"}} gap={16} vertical={!xl}>
                        <Flex style={{width: "100%"}} vertical={true}>
                            <Form.Item
                                label="Фамилия"
                                name="lastName"
                            >
                                <Input onChange={(e) => setResult(
                                    {
                                        ...result,
                                        otherpayer: {...result.otherpayer, surname: e.target.value}
                                    }
                                )}/>
                            </Form.Item>
                            <Form.Item
                                label="Имя"
                                name="firstName"
                            >
                                <Input onChange={(e) => setResult(
                                    {
                                        ...result,
                                        otherpayer: {...result.otherpayer, name: e.target.value}
                                    }
                                )}/>
                            </Form.Item>


                            <Form.Item
                                label="Отчество"
                                name="middleName"
                            >
                                <Input onChange={(e) => setResult(
                                    {
                                        ...result,
                                        otherpayer: {...result.otherpayer, patronymic: e.target.value}
                                    }
                                )}/>
                            </Form.Item>
                            <Form.Item
                                label="Снилс"
                                name="snils"
                            >
                                <Input.OTP
                                    length={11}
                                    onChange={(value) => {
                                        setResult(
                                            {
                                                ...result,
                                                otherpayer: {...result.otherpayer, snils: value}
                                            }
                                        )
                                    }}
                                    separator={(i) => {
                                        return ((i === 2 || i === 5 || i === 8) &&
                                            <div style={{width: "5px", height: "2px", backgroundColor: "lightgray"}}/>)
                                    }}
                                />
                            </Form.Item>
                        </Flex>
                        <Flex style={{width: "100%"}} vertical={true}>
                            <Form.Item
                                label="Пол"
                                name="sex"
                            >
                                <Select
                                    popupMatchSelectWidth
                                    onChange={(value) => setResult({
                                        ...result,
                                        otherpayer: {...result.otherpayer, gender: value}
                                    })}
                                    options={[
                                        {
                                            label: `Мужской`,
                                            value: `Male`
                                        },
                                        {
                                            label: `Женский`,
                                            value: `Female`
                                        }
                                    ]
                                    }
                                />
                            </Form.Item>
                            <Form.Item
                                label="Дата рождения"
                                name="birthday"
                            >
                                <DatePicker onChange={(e) => setResult(
                                    {
                                        ...result,
                                        otherpayer: {
                                            ...result.otherpayer,
                                            birthdate: e.format("YYYY-MM-DD")
                                        }
                                    }
                                )}/>
                            </Form.Item>
                            <Form.Item
                                label="Телефон"
                                name="phone"
                            >
                                <Input
                                    addonBefore={"+"}
                                    onChange={(e) => setResult(
                                        {
                                            ...result,
                                            otherpayer: {...result.otherpayer, telephone: `${e.target.value}`}
                                        }
                                    )}/>
                            </Form.Item>
                            <Form.Item
                                label="Почта"
                                name="email"
                            >
                                <Input onChange={(e) => setResult(
                                    {
                                        ...result,
                                        otherpayer: {...result.otherpayer, email: e.target.value}
                                    }
                                )}/>
                            </Form.Item>
                            <Form.Item
                                label="Гражданство"
                                name="country"
                            >
                                <Select
                                    placeholder={"Укажите гражданство"}
                                    options={countries.map((country: ICountry) => (
                                        {
                                            value: country.Code,
                                            label: country.Name
                                        }
                                    ))}
                                    onSelect={(value) => setResult(
                                        {
                                            ...result,
                                            otherpayer: {...result.otherpayer, citizenship: value}
                                        }
                                    )}
                                />
                            </Form.Item>
                        </Flex>
                    </Flex>
                </Form>
                <Typography.Text style={{fontSize: "20px"}} strong={true}>Загрузите документы</Typography.Text>
                <Typography.Text>Можно загрузить файлы формата .pdf, .jpg, .jpeg, .png и .zip размером до
                    5мб</Typography.Text>
                <Flex
                    style={{width: xl ? "70%" : "100%"}}
                    justify={"center"}
                    align={"center"}
                    vertical={true}
                    gap={16}
                >
                    <UploadItem title={"Главный разворот паспорта"} help={"Загрузите 2 и 3 страницу паспорта"}/>
                    <UploadItem title={"Место жительства"} help={"Загрузите 5 страницу паспорта"}/>
                    <UploadItem title={"Сведение о ранее выданных паспортах"} help={"Загрузите 19 страницу паспорта"}/>
                    <UploadItem title={"СНИЛС"} help={"Загрузите копию СНИЛС"}/>
                </Flex>
            </Flex>
        </Flex>
    )
}